import LicensePage from './LicensePage'
import type { VFC } from 'react'

const OneAppSubscriptionPage: VFC<any> = (props) => {
  return (
    <div className='cm-w-full'>
      <LicensePage {...props} />
    </div>
  )
}

export default OneAppSubscriptionPage
